import { render, staticRenderFns } from "./edit-userCourses-modal.vue?vue&type=template&id=35621504&scoped=true&"
import script from "./edit-userCourses-modal.vue?vue&type=script&lang=js&"
export * from "./edit-userCourses-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35621504",
  null
  
)

export default component.exports